<section class="topNavbar py-2 px-3 sticky-top" id="editNavbar">
  <div class="row align-items-center my-1">
    <div class="col-md-5 col-lg-5 d-flex my-2 my-md-auto flex-nowrap align-content-center align-items-center">
      <button mat-button class="cancel-editing" (click)="backTo();">
        <mat-icon>arrow_back</mat-icon>
        {{'cancel' | translate}}
      </button>
      <span class="component-headline text-center fw-light">"{{titleTask}}" </span>
    </div>
    <!-- desktop -->
    <div class="col-7 d-none d-lg-flex justify-content-end align-items-center">
      <div class="button-group">
        <button mat-button (click)="openWorkTaskTemplateDialog();">
          <mat-icon>settings</mat-icon><span class="d-none d-md-block">{{'workTask.template_settings'  | translate}}</span>
        </button>
        <button mat-button (click)="openWorkTaskTemplateAdvancedDialog();">
          <mat-icon>tune</mat-icon><span class="d-none d-md-block">{{'workTask.advanced_settings'  | translate}}</span>
        </button>
        <div class="vr custom-vr d-none d-md-inline-block"></div>
        <!-- <button mat-button class="cancel-editing" (click)="backTo();">
        {{'cancel' | translate}}
      </button> -->
      <button mat-button class="orange-button" id="btn-save" (click)="saveTaskTemplate();" [disabled]="!changesToSave || !tasktemplateUserRights_update">
        {{'workTask.publishWorkTask' | translate }}
      </button>
    </div>
  </div>
  <!-- mobile -->
  <div class="col-md-7 d-lg-none">
    <div class="button-group d-flex align-items-center justify-content-end">
      <button mat-icon-button (click)="openWorkTaskTemplateDialog();">
        <mat-icon>settings_applications</mat-icon>
      </button>
      <button mat-icon-button (click)="openWorkTaskTemplateAdvancedDialog();">
        <mat-icon>tune</mat-icon>
      </button>
      <div class="vr custom-vr d-none me-3 d-md-inline-block"></div>
      <button mat-button class="cancel-editing me-2" (click)="backTo();">
        <span class="d-none d-md-inline-block">{{'cancel' | translate}}</span>
        <mat-icon class="d-md-none mx-0">cancel</mat-icon>
      </button>
      <button mat-button class="orange-button" id="btn-save" (click)="saveTaskTemplate();" [disabled]="!changesToSave">
        <span class="d-none d-md-inline-block">{{'workTask.publishWorkTask' | translate }}</span>
        <mat-icon class="d-md-none mx-0">check_circle</mat-icon>
      </button>
    </div>
  </div>
</div>
</section>


<!-- mobile-message -->
<div class="row p-3 d-md-none" style="background-color: #dd2f2f;color:white">
  <div class="col-1 d-flex align-items-center align-content-center"><span class="material-symbols-outlined">error</span></div>
  <div class="col-11">{{'mobile_info' | translate}}</div>
</div>

<div class="container">
  <!-- <main class="container"> -->
  <div class="row mt-4">
    <div class="col-xs-6 col-md-6">
      <div class="d-flex mobile-wrapper justify-content-center align-self-center" [class.full-view]="phoneFullHeightView">
        <section class="mobile">
          <!--  *ngIf="!editTemp" -->
          <div class="d-flex mb-3 justify-content-center align-items-center">
            <h2 class="text-center mb-0 px-2">{{'content.preview' | translate}}</h2>
            <mat-icon class="text-orange" matTooltipPosition="before" matTooltip="{{'workTask.previewTooltip' | translate}}">info</mat-icon>
          </div>

          <div class="mobile-frame-container"></div>
          <div class="mobile-frame">  <!-- .disable-interaction -->
            <div class="group-title p-3">
              <div class="d-flex justify-content-between align-items-center" style="padding-top: 5px;">
                <div class="d-flex align-items-center">
                  <span class="material-symbols-outlined">
                    chevron_left
                  </span>
                  @if (taskTemplateGroupName) {
                    <span>{{ taskTemplateGroupName }}</span>
                  } @else {
                    {{'taskTemplates.ungrouped' | translate}}
                  }
                </div>

                @if (taskTemplateForm.value.hidden) {
                  <span class="material-symbols-outlined">
                    visibility_off
                  </span>
                }
              </div>
            </div>
            <h2 class="p-3 pb-0 mb-0"><strong>{{titleTask}}</strong></h2>

            @if (taskTemplate && taskTemplate.incomingTridys) {
              <div class="me-2 mt-1">
                @for (incoming of taskTemplate.incomingTridys; track incoming; let index = $index) {
                  <div>
                    <div class="p-1 ps-2 pe-2 d-flex m-1 w-100 align-items-center justify-content-between disable-interaction border rounded" >
                      <span> {{getContentTypeIdName(incoming.contentTypeId)}}</span>
                      <div class="d-flex flex-row align-items-center">
                        @if (includesSource(incoming.sources, 'scanQR')) {
                          <span class="material-symbols-outlined"> qr_code_scanner</span>
                        }
                        @if (includesSource(incoming.sources, 'scanNFC')) {
                          <span class="material-symbols-outlined">phonelink_ring </span>
                        }
                        @if (includesSource(incoming.sources, 'select')) {
                          <span class="material-symbols-outlined"> list </span>
                        }
                      </div>
                    </div>
                    <span class="text-muted p-1 m-1">0</span>
                  </div>
                }
              </div>
            }

            @for (task of sections; track task; let index = $index) {
              <div class="p-3 pt-1">
                <form>
                  <div class="section-title">{{task.title}}</div>
                  @for (item of task.fields; track item; let fieldNumber = $index) {
                    <div>
                      <div class="d-flex flex-row flex-wrap">
                        <!-- upload / action fields-->
                        @if (item.type=='barcode') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="tel" matInput placeholder="...">
                            <mat-icon class="text-orange" matSuffix>qr_code_scanner</mat-icon>
                          </mat-form-field>
                        }
                        @if (item.type=='tridy') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="tel" matInput placeholder="...">
                            <mat-icon class="text-orange" matSuffix>contactless</mat-icon>
                          </mat-form-field>
                        }
                        @if (item.type=='signature') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="tel" matInput placeholder="...">
                            <span matSuffix class="material-symbols-outlined px-2 mx-1 text-orange">signature</span>
                            <!--    <mat-icon class="text-orange" matSuffix>signature</mat-icon> -->
                          </mat-form-field>
                        }
                        @if (item.type=='nfc') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="tel" matInput placeholder="...">
                            <mat-icon class="text-orange" matSuffix>nfc</mat-icon>
                          </mat-form-field>
                        }
                        @if (item.type=='document') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="tel" matInput placeholder="...">
                            <mat-icon class="text-orange" matSuffix>attach_file</mat-icon>
                          </mat-form-field>
                        }
                        <!-- standard fields -->
                        <!-- stays hidden :) <span *ngIf="item.type=='hidden'">hidden</span> -->
                        @if (item.type=='boolean') {
                          <div class="pb-4 d-flex w-100 justify-content-between disable-interaction">
                            <div>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</div>
                            <div class="text-align-right px-1">
                              <mat-slide-toggle [checked]="item.defaultValue"></mat-slide-toggle>
                            </div>
                          </div>
                        }
                        @if (item.type=='dateTime') {
                          <div class="disable-interaction w-100">
                            @if (item.style=='dateTime') {
                              <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{item.title}}@if (item.mandatory) {
                                  <span>*</span>
                                }</mat-label>
                                <input matInput type="datetime-local" value ="" [readonly]="!tasktemplateUserRights_update" max="9999-12-31T23:59">
                              </mat-form-field>
                            }
                            @if (item.style=='date') {
                              <mat-form-field appearance="outline" class=" w-100">
                                <mat-label>{{item.title}}@if (item.mandatory) {
                                  <span>*</span>
                                }</mat-label>
                                <input matInput [matDatepicker]="picker">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                              </mat-form-field>
                            }
                            @if (item.style=='time') {
                              <mat-form-field appearance="outline" class="w-100">
                                <mat-label>{{item.title}}@if (item.mandatory) {
                                  <span>*</span>
                                }</mat-label>
                                @if (item.defaultValue) {
                                  <input matInput type="time" value ="{{isTime(item.defaultValue)}}" [readonly]="!tasktemplateUserRights_update">
                                }
                                @if (!item.defaultValue) {
                                  <input matInput type="time" value ="--:--" [readonly]="!tasktemplateUserRights_update">
                                }
                              </mat-form-field>
                            }
                          </div>
                        }
                        @if (item.type=='display') {
                          <div class="pb-3 d-flex w-100 justify-content-between disable-interaction">
                            <div>{{item.title}}</div>
                            <div class="text-align-right px-1">
                              <!-- <small>Value</small> -->
                            </div>
                          </div>
                        }
                        @if (item.type=='longText') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <textarea matInput></textarea>
                          </mat-form-field>
                        }
                        @if (item.type=='decimal' || item.type=='weight' || item.type=='number' || item.type=='currency') {
                          <mat-form-field appearance="outline" class="disable-interaction w-100">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="number" name="{{item.title}}" value="{{item.title}}" matInput>
                          </mat-form-field>
                        }
                        @if (item.type=='text') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <input type="text" name="{{item.title}}" value="{{item.title}}" matInput>
                          </mat-form-field>
                        }
                        @if (item.type=='options') {
                          <mat-form-field appearance="outline" class="w-100 disable-interaction">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <mat-select><!-- <mat-option value="-">-</mat-option> --></mat-select>
                          </mat-form-field>
                        }
                        @if (item.type=='showText') {
                          <div class="pt-2">
                            <div [innerHTML]="transformMarkDownText(item)" class="markdwn">  </div>
                          </div>
                        }
                        @if (item.type=='showImage') {
                          <div class="w-100 pt-2">
                            <mat-label>{{item.title}}@if (item.mandatory) {
                              <span>*</span>
                            }</mat-label>
                            <div class="m-auto d-flex justify-content-center">
                              <img src="{{loadShowImage(item.defaultValue)}}" style=" max-height:200px; max-width: 100%;">
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                </form>
              </div>
            }

            @if (taskTemplateForm.value.showImages) {
              <div class="p-3 pt-0 pb-0">
                <span class="text-muted text-uppercase">{{'taskTemplates.images' | translate}}</span>
                <div class="insertImgContainer mt-1" >
                  <label for="myfile" class="labelFile"> +  <input type="file" id="myfile" name="myfile" style="display: none;" accept=".jpg, .jpeg" disabled> </label>
                </div>
              </div>
            }

            @if (taskTemplateForm.value.showComment) {
              <div class="p-3 pt-0 pb-0">
                <span class="text-muted text-uppercase">{{'pass.comment' | translate}}</span>
                <div class="insertImgContainer mt-1"></div>
              </div>
            }
            <div class="p-3 mb-4">
              <button mat-button class="w-100" style="background-color:var(--warmOrange); color:white;">{{ 'submit' | translate }}</button>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="col-xs-6 col-md-6 mb-5">
      <div class="d-flex flex-row bd-highlight mb-4 align-items-center justify-content-end">
        <mat-slide-toggle class="screen-switcher" [(ngModel)]="phoneFullHeightView">{{ 'fullView' | translate }}</mat-slide-toggle>

        <div [matTooltip]="!tasktemplateUserRights_update ? ('home.tooltip' | translate) : null">
          <button mat-button class="secondary-gray-button-2 m-1 button-task  my-2 ms-2" (click)="addSection();" [disabled]="!tasktemplateUserRights_update">
            <mat-icon>add_circle</mat-icon> {{'taskTemplates.wt_section'  | translate}}
          </button>
        </div>
      </div>

      @if (sections.length==0) {
        <div class="p-4 mt-5 text-center" style="color: #a2a2a2;">{{'workTask.noFields' | translate}}</div>
      }

      <mat-accordion class="form-field-section" multi cdkDropList (cdkDropListDropped)="dropPanel($event)">
        @for (section of sections; track section; let index = $index) {
          <mat-expansion-panel cdkDrag [expanded]="index === 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span id="truncate-text">{{section.title}}</span>
              </mat-panel-title>
              <mat-panel-description>
                <button mat-icon-button [matMenuTriggerFor]="editDelete" (click)="$event.stopPropagation()">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #editDelete="matMenu">
                  <button mat-menu-item (click)="editTitleSection(section.title, index)" [disabled]="!tasktemplateUserRights_update"><mat-icon>edit</mat-icon> {{"taskTemplates.editSectionTitle" | translate}}</button>
                  <button mat-menu-item (click)="duplicateSection(section, index);" [disabled]="!tasktemplateUserRights_update"><mat-icon>content_copy</mat-icon> {{"taskTemplates.duplicateSection" | translate}}</button>
                  <button mat-menu-item (click)="deleteSection(section.title, index);" [disabled]="!tasktemplateUserRights_update"><mat-icon class="material-symbols-outlined delete">delete</mat-icon> {{"taskTemplates.deleteSection" | translate}}</button>
                </mat-menu>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <!-- CONTENT -->
            <div class="expansion-panel-content">
              <div cdkDropList [id]="'dropListField-' + index" #dropList="cdkDropList" [cdkDropListData]="section" [cdkDropListConnectedTo]="connectedDropLists(index)" class="shadow-sm rounded" (cdkDropListDropped)="drop($event,index)" [ngStyle]="{'height': section.fields?.length==0 ? '50px' : 'auto'}">
                @for (item of section.fields; track item; let fieldNumber = $index) {
                  <div cdkDrag id="fields-list" (click)="openFieldDialog(item, fieldNumber, index);" class="d-flex"> <!-- cdkDrag -->
                    <div class="d-flex flex-row flex-nowrap">
                      @if (item.type=='barcode') {
                        <span class="material-symbols-outlined p-2 text-orange">qr_code_scanner</span>
                      }
                      @if (item.type=='signature') {
                        <span class="material-symbols-outlined p-2 text-orange">signature</span>
                      }
                      @if (item.type=='boolean') {
                        <span class="material-symbols-outlined p-2 text-orange">toggle_on</span>
                      }
                      @if (item.type=='currency') {
                        <span class="material-symbols-outlined p-2 text-orange">euro</span>
                      }
                      @if (item.type=='dateTime') {
                        <span class="material-symbols-outlined p-2 text-orange">calendar_month</span>
                      }
                      @if (item.type=='decimal') {
                        <span class="material-symbols-outlined p-2 text-orange">numbers</span>
                      }
                      @if (item.type=='display') {
                        <span class="material-symbols-outlined p-2 text-orange">visibility</span>
                      }
                      @if (item.type=='document') {
                        <span class="material-symbols-outlined p-2 text-orange">attach_file</span>
                      }
                      @if (item.type=='hidden') {
                        <span class="material-symbols-outlined p-2 text-orange">visibility_off</span>
                      }
                      @if (item.type=='longText') {
                        <span class="material-symbols-outlined p-2 text-orange">subject</span>
                      }
                      @if (item.type=='number') {
                        <span class="material-symbols-outlined p-2 text-orange">pin</span>
                      }
                      @if (item.type=='text') {
                        <span class="material-symbols-outlined p-2 text-orange">text_format</span>
                      }
                      @if (item.type=='tridy') {
                        <span class="material-symbols-outlined p-2 text-orange">contactless</span>
                      }
                      @if (item.type=='options') {
                        <span class="material-symbols-outlined p-2 text-orange">list</span>
                      }
                      @if (item.type=='weight') {
                        <span class="material-symbols-outlined p-2 text-orange">weight</span>
                      }
                      @if (item.type=='nfc') {
                        <span class="material-symbols-outlined p-2 text-orange">nfc</span>
                      }
                      @if (item.type=='showText') {
                        <span class="material-symbols-outlined p-2 text-orange">edit_note</span>
                      }
                      @if (item.type=='showImage') {
                        <span class="material-symbols-outlined p-2 text-orange">image</span>
                      }
                      <div class="d-flex flex-column justify-content-center">
                        <span class="text-break text-wrap">{{item.title}}</span>
                        <span class="text-muted text-break text-wrap" style="font-size: 11px;">{{item.key}}</span>
                      </div>
                    </div>
                    <button mat-icon-button [disabled]="!tasktemplateUserRights_update" (click)="deleteFieldOfSection(fieldNumber, index);" id="btn-delete-field" class="delete-icon">
                      <span class="material-symbols-outlined">
                        delete
                      </span>
                    </button>
                  <!-- </div> -->
                </div>
              }
            </div>
            <mat-action-row>
              <div [matTooltip]="!tasktemplateUserRights_update ? ('home.tooltip' | translate) : null">
                <button mat-button class="secondary-gray-button my-2"[matMenuTriggerFor]="fieldTypes" [disabled]="!tasktemplateUserRights_update">
                  <mat-icon>add_circle</mat-icon> {{'workTask.addNewElement' | translate}}
                </button>
                <mat-menu #fieldTypes="matMenu" xPosition="before" yPosition="below">
                  @for (element of elementTypes; track element; let elementIndex = $index) {
                    <button mat-menu-item (click)="addFieldToSection(element.type, index);" [disabled]="!tasktemplateUserRights_update">
                      <mat-icon class="material-symbols-outlined">{{element.icon}}</mat-icon> {{element.translation | translate}}
                    </button>
                  }
                </mat-menu>
              </div>
            </mat-action-row>
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>

  </div>
</div>
</div>